module.exports = __webpack_public_path__ + "static/media/STAFFING_SOLUTION2.45d7be30.jpg";